import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, CalendarDays, Dumbbell, Ruler, User, LogOut } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";

const NAV = [
  { label: "Ana Sayfa", to: "/member", icon: Home, end: true },
  { label: "Randevularım", to: "/member/appointments", icon: CalendarDays },
  { label: "Antrenmanım", to: "/member/workout", icon: Dumbbell },
  { label: "Ölçümlerim", to: "/member/measurements", icon: Ruler },
  { label: "Profil", to: "/member/profile", icon: User },
];

export default function MemberLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-[#0B0B0E] flex flex-col max-w-lg mx-auto relative border-x border-[#14141C]">
      <header className="h-14 sticky top-0 z-20 bg-[#0B0B0E]/90 backdrop-blur-xl border-b border-[#1A1A24] flex items-center justify-between px-4">
        <Logo />
        <div className="flex items-center gap-1">
          <NotificationBell role={user?.role} />
          <button onClick={doLogout} data-testid="member-logout-button" className="p-2 rounded-lg text-[#68687B] hover:text-[#EF4444]"><LogOut size={18} /></button>
        </div>
      </header>

      <main className="flex-1 p-4 pb-28 animate-fade-up">
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <nav className="fixed bottom-0 inset-x-0 max-w-lg mx-auto z-30 bg-[#0E0E14]/95 backdrop-blur-xl border-t border-[#1A1A24] px-2 py-2" data-testid="member-bottom-navigation">
        <div className="flex items-center justify-around">
          {NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink key={item.to} to={item.to} end={item.end}
                data-testid={`member-nav-${item.to.split("/").pop() || "home"}`}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-1 px-2 py-1 rounded-xl transition-all ${isActive ? "text-[#FF5500]" : "text-[#68687B]"}`
                }>
                {({ isActive }) => (
                  <>
                    <div className={`p-1.5 rounded-xl transition-all ${isActive ? "bg-[#FF5500]/15" : ""}`}>
                      <Icon size={20} strokeWidth={2.2} />
                    </div>
                    <span className="text-[10px] font-semibold">{item.label}</span>
                  </>
                )}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
